
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { uniqBy } from "lodash";
import { addComment, useGetComment } from "repositories/task-management-repository";
import toast from "react-hot-toast";
import { useQueryClient } from "react-query";
const pageSize = 10;

const useDashBoardTaskCommentModule = (myTask) => {
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [showLoader, setShowLoader] = useState(false);
    const [comments, setComments] = useState([]);
    const history = useHistory();
    const queryClient = useQueryClient();

    const { isLoading : commentLoading, data : CommentData,  refetch : refetchComment } = useGetComment(
        myTask?.id,
        pageNumber,
        pageSize,
    );
    const goToPreviousScreen = () => {
        history.goBack();
    };

    useEffect(() => {
        if (pageNumber === 1) {
            if (!commentLoading && CommentData && CommentData?.data?.length) {
                setComments(uniqBy([...CommentData?.data], "id"));
                setTotalItems(CommentData?.data?.pagination?.totalItems);
            }
        }
        else if (!commentLoading && CommentData?.data && CommentData?.data) {
            setComments(prev => uniqBy([...prev, ...CommentData?.data], "id"));
            setTotalItems(CommentData?.data?.pagination?.totalItems);
        }
    }, [commentLoading, CommentData?.data]);

   const addComments =async (taskAssignmentId, params) => {
        setShowLoader(true);
        try {
          const res = await addComment(taskAssignmentId, params);
          if (res?.status) {
            setShowLoader(false);
            setPageNumber(1);
            queryClient.invalidateQueries(["/addComment/staff", taskAssignmentId, pageNumber, pageSize]);
            refetchComment();
            toast.success(res.message);
          }
        } catch (e) {
          setShowLoader(false);
          toast.error(e.message);
        }
      }

      const anyLoading =   commentLoading || showLoader ;

    return {
        data: {
            anyLoading,
            totalItems,
            comments,
            pageNumber
        },
        methods: {
            goToPreviousScreen,
            setPageNumber,
            addComments
        }
    }
}

export default useDashBoardTaskCommentModule;
